<template>
    <div class="mit-maps-page mit-page">
        <v-snackbar top :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
            <b>{{ status.message }}</b>
        </v-snackbar>
        <v-container fluid>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card">
              <v-card-title>My Actions Required</v-card-title>
              <v-card-subtitle class="caption">View and address human resource related tasks required by you.</v-card-subtitle>
              <v-divider></v-divider>
              <v-toolbar dense flat>
                <v-btn v-if="filterState" @click="filterStateChange(null)" class="ma-1 mr-2" color="primary">{{ filterState.name }}<v-icon class="ml-2">mdi-close-circle</v-icon></v-btn>
                <v-menu v-if="filterState == null" bottom >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ma-1 mr-1" color="primary" outlined text v-bind="attrs" v-on="on">State<v-icon>mdi-menu-down</v-icon></v-btn>
                    </template>
                    <v-list >
                        <v-list-item v-for='s in requestStates':key="s.val" @click="filterStateChange(s)" link>
                            <v-list-item-title>{{ s.name }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <v-btn v-if="filterType" @click="filterTypeChange(null)" class="ma-1 mr-2" color="primary">{{ filterType.name }}<v-icon class="ml-2">mdi-close-circle</v-icon></v-btn>
                <v-menu v-if="filterType == null" bottom >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ma-1 mr-1" color="primary" outlined text v-bind="attrs" v-on="on">Types<v-icon>mdi-menu-down</v-icon></v-btn>
                    </template>
                    <v-list >
                        <v-list-item v-for='t in requestTypes':key="t.val" @click="filterTypeChange(t)" link>
                            <v-list-item-title>{{ t.name }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <v-spacer></v-spacer>
                <v-text-field
                      class="pr-5"
                      v-model="searchText"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                <!-- <v-btn icon>
                    <v-icon>mdi-magnify</v-icon>
                </v-btn> -->
                    <v-btn color="primary">New Request</v-btn>

                </v-toolbar>
              <v-card-text>
                    <BaseMitDataTable
                    title=""
                    :editable="false"
                    :showControlHeader="false"
                    :headers="headers"
                    :items="requests"
                    :getNewItem="newRequestModel"
                    :getCopyItem="editRequestModel"
                    @edit-begin="editRequest"
                    @delete="deleteRequest"
                    >
                    <template v-slot:item.icon="{ item }">
                        <v-icon v-if="item.recurring" color="primary darken-1" class="pr-3">mdi-calendar-refresh-outline</v-icon>
                        <v-icon v-else color="primary darken-1" class="pr-3">mdi-calendar-today-outline</v-icon>
                    </template>
                    <template v-slot:item.action="{ item }">
                       {{ item.person.state.actionHint }}
                    </template>
                    <template v-slot:item.requestType="{ item }">
                        <!-- <v-chip outlined :color="item.requestType.color">{{ item.requestType.name }}</v-chip> -->
                        <v-icon>{{item.requestType.icon}}</v-icon>
                    </template>
                    <template v-slot:item.state="{ item }">
                        <v-chip label :outlined="item.state.outlined" :color="item.state.color">{{ item.state.name }}</v-chip>
                    </template>
                    <template v-slot:item.comments="{ item }">
                        <v-icon class="pr-1">mdi-comment-outline</v-icon>{{item.comments.length}}
                    </template>
                    <template v-slot:item.lastEditDt="{ item }">
                        {{ BaseMitDateTimeService.formatTimeAgo(item.lastEditDt, true) }}
                    </template>
                    <template v-slot:item.open="{ item }">
                        <v-btn small outlined rounded color="primary">Open</v-btn>
                    </template>
                    <template v-slot:item.accept="{ item }">
                        <v-btn small rounded color="light-green lighten-2">Accept</v-btn>
                    </template>
                    <template v-slot:item.reject="{ item }">
                        <v-btn small outlined rounded color="red darken-4">Reject</v-btn>
                    </template>
                    
                </BaseMitDataTable>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
</template>

<script>
    import BaseMitDataTable from '../../../base/components/BaseMitDataTable.vue';
    import BaseMitUrlParams from '../../../base/components/BaseMitUrlParams.vue';
    import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';

    import MitRequestApprovalService from '../../services/MitRequestApprovalService.js';
    import BaseMitDateTimeService from '../../services/BaseMitDateTimeService.js'
    
    export default {
        name: 'MitMyReqeustsPage',
        components: {
            BaseMitLoading,
            BaseMitUrlParams,
            BaseMitDataTable
        },
        data: function() {
            return {
                status:{
                    display:false,
                    timeout:3000,
                    message:'Saved!',
                    color:'primary'
                },
                dialog:false,
                loading:true,
                requests:[],
                currentRequestId:null,
                BaseMitDateTimeService:new BaseMitDateTimeService(),
                headers:[
                    {text: 'Type',sortable: true,value: 'requestType'},
                    {text: '',sortable: false,value: 'open', width: '5%',filterable:false, class: 'doNotPrint', cellClass:'doNotPrint'},
                    {text: 'Action',sortable: false,value: 'action',},
                    {text: 'Description',sortable: false,value: 'description',},
                    {text: 'Last Modified',sortable: true,value: 'lastEditDt',},
                    
                    {text: '',sortable: false,value: 'accept', width: '5%',filterable:false, class: 'doNotPrint', cellClass:'doNotPrint'},
                    {text: '',sortable: false,value: 'reject', width: '5%',filterable:false, class: 'doNotPrint', cellClass:'doNotPrint'},
                    // {text: 'Actions', value: 'actions', sortable: false, width: '5%', filterable:false, class: 'doNotPrint', cellClass:'doNotPrint' }
                ],
                searchText:'',
                //requestStatesDict:MitRequestApprovalService.getStateDict(),
                filterState:null,
                requestStates:MitRequestApprovalService.getStateArray(),
                filterType:null,
                requestTypes:MitRequestApprovalService.getTypesArray(),
                filterOwner:null,
                uniqueOwnerList:[]
            }
        },
        created(){
            this.getRequests();
        },
        mounted() {
            if(this.$route.params.id){
                this.currentRequestId = this.$route.params.id;
                this.dialog = true;
            }
        },
        methods : {
            updateUrl(id){
                let url;

                if(id !== null && id.length > 0){
                    url = {
                        path: '/my/requests/'+ id,
                        query: {}
                    }
                }
                else{
                    url = {
                        path: '/my/requests',
                        query: {}
                    }
                }
                
                //test to make sure we don't try to change to the same url.
                //the router doesn't like this
                if(this.$router.currentRoute.path != url.path){
                this.$router.push(url);
                }
            },
            newRequestModel(){
                return {};
            },
            editRequestModel(item){
                return item;
            },
            editRequest(request){
                this.updateUrl(request.id);
                this.dialog = true;
                this.currentReservationUniqueId = reservation.uniqueId;
            },
            getRequests(){
                this.loading = true;
                MitRequestApprovalService.getActions()
                    .then((requests) => {
                        this.requests = requests;
                        //load unique requests for UI filter
                        //this.uniqueRequestOwners(this.requests);
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.status.message = 'An error occurred trying to get requests.';
                        console.log('An error occurred trying to get requests list', error);
                    });
            },
            editRequest(){

            },
            deleteRequest(){

            },
            filterStateChange(state){
                this.filterState = state;
            },
            filterTypeChange(type){
                this.filterType = type;
            },
            filterOwnerChange(owner){
                this.filterOwner = owner;
            },
            uniqueRequestOwners(request){
                this.uniqueOwnerList = [];
                let unique = {};

                for(let x = 0; x < request.length; x++){
                    console.log('TEST', unique.hasOwnProperty(request[x].owner.csailId))
                    if(unique.hasOwnProperty(request[x].owner.csailId) === false){
                        unique[request[x].owner.csailId] = true;
                        this.uniqueOwnerList.push(request[x].owner);
                    }
                    // if(this.uniqueOwnerList.indexOf(request[x].owner) < 0){
                    //     this.uniqueOwnerList.push(request[x].owner);
                    // }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .mit-info-card {
    width:100%;
    height:100%;
    }
</style>
